export const CLEAR_API_ERRORS = '@api/CLEAR_API_ERRORS';